import { render, staticRenderFns } from "./TelActions.vue?vue&type=template&id=0515932c&scoped=true&"
import script from "./TelActions.vue?vue&type=script&lang=js&"
export * from "./TelActions.vue?vue&type=script&lang=js&"
import style0 from "./TelActions.vue?vue&type=style&index=0&id=0515932c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0515932c",
  null
  
)

export default component.exports